import React from 'react'
import NavigationTabs from '../nav/NavigationTabs';
import Moment from "react-moment"

export default class Invoices extends React.Component {
  state = {
    dataLoaded: false
  }
  componentDidMount(){
    const { user, fetch } = this.props;
    fetch(user._id).then(() => {
      this.setState({
        ...this.state,
        dataLoaded: true
      })
    })
  }

  render() {
    const { dataLoaded } = this.state;
    const { invoices } = this.props;
    return (
      <div>
        <NavigationTabs
          title="Settings"
          set="settings"
          subtitle="Invoices"
          currentUser={this.props.currentUser}
          activeRoute="/settings/billing"/>
        {
          dataLoaded ? (
            <div>
              <table className="statement-table">
                <thead>
                  <tr>
                    <td>Bill Date</td>
                    <td style={{'width': '200px'}}>Billing Period</td>
                    <td>Description</td>
                    <td>Amount Paid</td>
                  </tr>
                </thead>
                <tbody>

                  {
                    Object.values(invoices).map((invoice, index) => {
                      return (<tr key={index}>
                        <td><Moment className="text-muted" format="D MMM YYYY">{invoice.createdAt}</Moment></td>
                        <td style={{'width': '200px'}}>
                            <Moment className="text-muted" format="D MMM YYYY">{invoice.billingPeriodStartDate}</Moment> -
                            <Moment className="text-muted" format="D MMM YYYY">{invoice.billingPeriodEndDate}</Moment>
                        </td>
                        <td>
                          {invoice.description}
                        </td>
                        <td>${invoice.amount}</td>
                      </tr>)
                    })
                  }
                </tbody>
              </table>
            </div>
          ) : null

        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/Invoices.js